document.addEventListener('DOMContentLoaded', function() {
  const faqQuestions = document.querySelectorAll('.faq-question');

  // Ouvrir la première FAQ par défaut
  if (faqQuestions.length > 0) {
    const firstQuestion = faqQuestions[0];
    const firstAnswerId = firstQuestion.getAttribute('aria-controls');
    const firstAnswer = document.getElementById(firstAnswerId);
    
    firstQuestion.setAttribute('aria-expanded', 'true');
    if (firstAnswer) {
      firstAnswer.removeAttribute('hidden');
    }
  }

  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const answerId = this.getAttribute('aria-controls');
      const answer = document.getElementById(answerId);

      // Fermer toutes les autres FAQs
      faqQuestions.forEach(function(otherQuestion) {
        if (otherQuestion !== question) {
          otherQuestion.setAttribute('aria-expanded', 'false');
          const otherAnswerId = otherQuestion.getAttribute('aria-controls');
          const otherAnswer = document.getElementById(otherAnswerId);
          if (otherAnswer) {
            otherAnswer.setAttribute('hidden', '');
          }
        }
      });

      // Ouvrir/fermer la FAQ cliquée
      if (isExpanded) {
        this.setAttribute('aria-expanded', 'false');
        if (answer) {
          answer.setAttribute('hidden', '');
        }
      } else {
        this.setAttribute('aria-expanded', 'true');
        if (answer) {
          answer.removeAttribute('hidden');
        }
      }
    });
  });
});



// WEBPACK FOOTER //
// ./scripts/modules/faq.js